<div class="table-responsive">
  <table class="table table-striped tbl-scrollable">
    <thead class="thead-light">
      <tr>
        <th scope="col" width="10%" class="text-center"><button class="btn btn-outline-danger py-0 delete-button"
            [disabled]="selectedAdmins.length < 1" data-toggle="modal" data-target="#deleteAdmin"><i
              class="fa fa-trash"></i></button>
        </th>
        <th scope="col" width="12%"></th>
        <th scope="col" width="16%" class="d-table-cell d-sm-none">Name</th>
        <th scope="col" class="d-none d-sm-table-cell">Name</th>
        <th scope="col" width="21%" class="d-none d-sm-table-cell">Email</th>
        <th scope="col" width="16%" class="d-none d-sm-table-cell">Phone</th>

        <!-- <th scope="col" class="pr-0">Status</th> -->
        <th scope="col" width="13%">Role</th>
        <th scope="col" width="12%" class="d-none d-sm-table-cell">Last Sign-In</th>
      </tr>
    </thead>
    <tbody class="max-height-57">
      <tr *ngFor="let admin of admins; let i = index">
        <th width="10%" scope="row" class="text-center pr-0">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" name="checkbox" class="custom-control-input" [disabled]="admin.id == loggedInUserId"
              id="admin_{{i}}" (change)="onAdminSelected(admin.id)">
            <label class="custom-control-label" for="admin_{{i}}"></label>
          </div>
        </th>
        <td width="12%" class="cursor-pointer text-center pl-0" (click)="navigateToDetailPage(admin)">
          <!-- <img class="home-grid-image" src="{{admin.avatar}}" alt="{{admin.name}}" /> -->
          <img *ngIf="admin.image" class="home-grid-image" src="{{admin.image}}" alt="{{admin.name}}" />
          <img *ngIf="!admin.image" class="home-grid-image" src="assets/images/user_male.png" alt="{{admin.name}}" />
          <!-- <i class="fa fa-window-minimize" style="font-size: 1.1rem; line-height: 0px; color: red;"></i> -->
          <br>
          <!-- <i class="fa fa-window-minimize" style="line-height: 0px; color: green;"></i> -->
          <i *ngIf="admin.status=='ACTIVE'" class="fa fa-window-minimize" style="line-height: 0px; color: green;"></i>
          <i *ngIf="admin.status=='INVITED'" class="fa fa-window-minimize"
            style="line-height: 0px; color: rgb(240, 173, 68);"></i>
          <i *ngIf="admin.status=='DISABLED' || admin.status=='INACTIVE'" class="fa fa-window-minimize"
            style="line-height: 0px; color: red"></i>
        </td>

        <td width="16%" class="cursor-pointer d-table-cell d-sm-none" (click)="navigateToDetailPage(admin)">
          <b>{{admin.name}}</b><br>
          <span class="mt-2">{{admin.username}}</span><br>
          <span class="mt-2">{{admin.phone}}</span>
        </td>
        <td class="cursor-pointer d-none d-sm-table-cell" (click)="navigateToDetailPage(admin)">{{admin.name}}</td>
        <td width="21%" class="cursor-pointer d-none d-sm-table-cell" (click)="navigateToDetailPage(admin)">{{admin.username}}</td>
        <td width="16%" class="cursor-pointer d-none d-sm-table-cell" (click)="navigateToDetailPage(admin)">{{admin.phone}}</td>
        <td width="13%" class="cursor-pointer">
          <div *ngFor="let role of admin.roles" (click)="navigateToDetailPage(admin)">
            {{role | role_display}}</div>
        </td>
        <td width="12%" class="cursor-pointer" (click)="navigateToDetailPage(admin)">{{admin.lastSignedIn | timeAgo}}</td>
      </tr>
    </tbody>
  </table>
</div>


<div class="modal fade" id="deleteAdmin" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="deleteAdminTitle">Delete User(s)</h5>
        <button type="button" class="close" (click)="cancelDeleteUser()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <h5 class="mt-5 mb-5">Confirm deleting selected user(s) ?</h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" (click)="cancelDeleteUser()" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" data-dismiss="modal" (click)="onDeleteAdmins()">OK</button>
      </div>
    </div>
  </div>
</div>